module.exports = __webpack_public_path__ + "img/3.83f3f029.png";